<template>
  <div class="card text-center pt-2 my-2 position-relative" style="width: 18rem">
    
    <!-- User Component Icons -->
    <div v-if="moduleCreator.isUserComponent" class="position-absolute top-0 start-0 m-2 p-1 bg-light rounded shadow-sm d-flex gap-1" style="z-index: 10;">
      <span @click.stop="$emit('edit')" class="action-icon d-inline-flex align-items-center justify-content-center rounded p-1" title="Rename Component">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-pencil-fill text-dark" viewBox="0 0 16 16">
          <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
        </svg>
      </span>
      <span @click.stop="$emit('delete')" class="action-icon d-inline-flex align-items-center justify-content-center rounded p-1" title="Delete Component">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-x-lg text-danger" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"/>
          <path fill-rule="evenodd" d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"/>
        </svg>
      </span>
    </div>

    <!-- User Component Badge -->
    <div v-if="moduleCreator.isUserComponent" class="position-absolute top-0 end-0 m-2">
      <span class="badge bg-info text-dark" style="font-size: 0.75rem; font-weight: bold; padding: 0.3em 0.6em;">User JSON</span>
    </div>

    <div class="w-auto mx-auto mt-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="150"
        height="100"
        :fill="fillColor"
        :stroke="fillColor"
        :stroke-width="strokeWidth"
        :viewBox="viewBoxStr"
      >
        <SvgModuleVue
          v-if="moduleCreator.isUserComponent"
          :id="'board-item-' + Math.random().toString(36).substr(2, 9)"
          :topLeftCorner="moduleCreator.pendingModule.elementsToRender.topLeftCorner"
          :borderShapes="moduleCreator.pendingModule.elementsToRender.borderShapes"
          :maskShapes="moduleCreator.pendingModule.elementsToRender.maskShapes"
          :centerPoint="moduleCreator.pendingModule.elementsToRender.centerPoint"
        />
        <component v-else :is="moduleCreator.sample" />
      </svg>
    </div>

    <div class="card-body">
      <h5 class="card-title">{{ moduleCreator.moduleName }}</h5>
      <p class="card-text text-muted mb-1" v-if="moduleCreator.isUserComponent" style="font-size: 0.85rem;">User component</p>
      <p class="card-text">{{ moduleCreator.description }}</p>
      <a href="#" class="btn btn-outline-success">Create</a>
    </div>
  </div>
</template>

<script>
import SampleChamber from "@/assets/moduleSamples/SampleChamber.vue";
import SampleDelayChannel from "@/assets/moduleSamples/SampleDelayChannel.vue";
import SampleFilter from "@/assets/moduleSamples/SampleFilter.vue";
import SampleTeslaValve from "@/assets/moduleSamples/SampleTeslaValve.vue";
import SampleDroplet from "@/assets/moduleSamples/SampleDroplet.vue";
import SampleTransition from "@/assets/moduleSamples/SampleTransition.vue";
import SampleUserComponent from "@/assets/moduleSamples/SampleUserComponent.vue";
import SvgModuleVue from "./SvgModule.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    SampleChamber,
    SampleDelayChannel,
    SampleFilter,
    SampleTeslaValve,
    SampleDroplet,
    SampleTransition,
    SampleUserComponent,
    SvgModuleVue
  },
  props: {
    moduleCreator: Object
  },
  emits: ['delete', 'edit'],
  data() {
    return {
      fillColor: "dodgerblue",
      strokeWidth: 7
    };
  },
  computed: {
    viewBoxStr() {
      if (this.moduleCreator.isUserComponent) {
        const elements = this.moduleCreator.pendingModule.elementsToRender;
        if (!elements || !elements.topLeftCorner || !elements.centerPoint) {
          return undefined;
        }
        const x = elements.topLeftCorner[0];
        const y = elements.topLeftCorner[1];
        const w = (elements.centerPoint[0] - x) * 2;
        const h = (elements.centerPoint[1] - y) * 2;
        return `${x} ${y} ${w} ${h}`;
      }
      return undefined;
    }
  }
});
</script>

<style scoped>
.action-icon {
  cursor: pointer;
  transition: background-color 0.15s ease-in-out;
}
.action-icon:hover {
  background-color: #d1d5db;
}
</style>
